import { LoaderFunction } from "react-router-dom";

import { removeProfileInfo } from "@/api/tokens.ts";

export const removeProfileInfoLoader: LoaderFunction = (): null => {
  removeProfileInfo();
  return null;
};
